import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// safer root check (prevents silent failure if element missing)
const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}